/**
 * Copyright (c) Asseco Business Solutions S.A. All rights reserved.
 */
import {MENU_URL} from "../common/Urls";
import {storageManager} from "../../index";

export async function fetchMenu() {
    return await storageManager.checkClientSessionStorageItem("menu", MENU_URL);
}